import AssetSelector from "../util/asset-selector/AssetSelector.jsx";
import './Search.scss'
import {scrollToTop, useNavigation} from "../util/navigation/navigation.js";
import {APP_ROUTES} from "../../App.jsx";
import {useDispatch, useSelector} from "react-redux";
import {getSubPathCache} from "../../ducks/user-duck.js";
import {closePopup} from "../../ducks/popup-duck.js";

export default () => {

    const dispatch = useDispatch()

    const {navigateTo} = useNavigation(scrollToTop)
    const subPathCache = useSelector(getSubPathCache)
    let route = subPathCache ? APP_ROUTES.history.replace('history', subPathCache) : APP_ROUTES.history

    const selectAsset = assetId => {
        navigateTo(route, {filterId: assetId})
        dispatch(closePopup())
    }

    return (
        <div className='search'>
            <AssetSelector
                selectAsset={selectAsset}
                isSearchFocused={true}
            />
        </div>
    )
}